export function rangeArray(from: number, to: number, interval: number = 1): number[] {
  const array: number[] = [];
  for (let i: number = from; i < to; i += interval) {
    array.push(i);
  }
  return array;
}
